import React, { useState, useEffect } from 'react';
import { Box, Fab, useMediaQuery, useTheme } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import Sidebar from '../Sidebar/Sidebar'; // Adjust path as needed
import MobileNav from './MobileNav';
import AIAssistantPanel from '../Assistant/AIAssistantPanel';
import '../../styles/ModernSystem.css';

const MainLayout = ({ children }) => {
    const theme = useTheme();
    // Use 'md' for sidebar collapse, 'sm' for bottom nav switch
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [isCollapsed, setIsCollapsed] = useState(false);
    // Estado local del panel del asistente NutriAgent.
    const [assistantOpen, setAssistantOpen] = useState(false);

    // Auto-collapse sidebar on tablet
    useEffect(() => {
        setIsCollapsed(isTablet);
    }, [isTablet]);

    return (
        <Box className="modern-app-shell" sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f8fafc', flexDirection: 'column' }}>
            {/* Sidebar only on Desktop/Tablet */}
            {!isMobile && (
                <Sidebar
                    isCollapsed={isCollapsed}
                    onToggle={() => setIsCollapsed(!isCollapsed)}
                />
            )}

            <Box
                component="main"
                className="modern-app-content"
                sx={{
                    flexGrow: 1,
                    // If mobile, no left margin. If desktop, sidebar width.
                    ml: isMobile ? 0 : (isCollapsed ? '88px' : '280px'),
                    p: isMobile ? 2 : 4,
                    pb: isMobile ? 10 : 4, // Padding for bottom nav
                    bgcolor: '#f8fafc',
                    minHeight: '100vh',
                    transition: 'all 0.3s ease',
                    width: isMobile ? '100%' : `calc(100% - ${isCollapsed ? '88px' : '280px'})`
                }}
            >
                {children}
            </Box>

            {/* Bottom Nav only on Mobile */}
            {isMobile && <MobileNav />}

            {/* FAB del asistente: fijo abajo-derecha. En móvil se eleva por
                encima de la MobileNav (altura 74) para no quedar solapado. */}
            <Fab
                color="primary"
                aria-label="Abrir asistente"
                onClick={() => setAssistantOpen(true)}
                sx={{
                    position: 'fixed',
                    right: 16,
                    bottom: isMobile ? 90 : 24,
                    // Aspecto (degradado + brillo + chispa) heredado del estilo de
                    // acción destacada global; aquí solo posición y apilado.
                    // Por encima de la MobileNav (zIndex 1300) pero bajo el Drawer.
                    zIndex: 1301,
                }}
            >
                <ChatBubbleOutlineIcon />
            </Fab>

            {/* Panel lateral del asistente (disponible en todas las páginas privadas). */}
            <AIAssistantPanel
                open={assistantOpen}
                onClose={() => setAssistantOpen(false)}
            />
        </Box>
    );
};

export default MainLayout;
